var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.914,
    height: 27.914,
    viewBox: "0 0 27.914 27.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(7.5)",
    fill: "none",
    stroke: "#f9c977",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    x1: 11,
    y2: 11,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#f9c977",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.926446fec0e58bb1415be15653c4007c.svg";
export { ForwardRef as ReactComponent };